import { Component, OnDestroy, OnInit } from '@angular/core';
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';
import { TranslateService, LangChangeEvent } from '@ngx-translate/core';
import { Subscription } from 'rxjs/Subscription';
import { JhiLanguageService } from 'ng-jhipster';

import { LanguageHelper } from '../../../shared';
import { LoginService, Principal } from '../../../services';
import { LoginModalService } from '../../login';

@Component({
    selector: 'qms-page-header',
    templateUrl: './page-header.component.html',
    styleUrls: [
        './page-header.component.css',
        './navbar/navbar.component.css'
    ]
})
export class PageHeaderComponent implements OnInit, OnDestroy {
    private modal: NgbModalRef;
    private languageChangeSubscription: Subscription;

    public flags: { [language: string]: string };
    public currentLanguage: string;
    public languages: any[];

    constructor(private loginService: LoginService,
                private loginModalService: LoginModalService,
                private translateService: TranslateService,
                private principal: Principal,
                private languageService: JhiLanguageService,
                private languageHelper: LanguageHelper,
                private router: Router) {
        this.flags = {};
    }

    ngOnInit(): void {
        this.languageHelper.getAll().then((languages) => {
            this.languages = languages;
            for (let i = 0; i < this.languages.length; i++) {
                const language = this.languages[i];
                this.flags[language] = require('../../../../content/images/flags/' + language + '.png');
            }
        });
        this.languageService.getCurrent().then((language: string) => {
            this.currentLanguage = language;
        });
        this.languageChangeSubscription = this.translateService.onLangChange.subscribe((event: LangChangeEvent) => {
            this.currentLanguage = event.lang;
        });
    }

    ngOnDestroy(): void {
        this.languageChangeSubscription.unsubscribe();
    }

    isAuthenticated() {
        return this.principal.isAuthenticated();
    }

    username(): String {
        return this.principal.getUserFirstName() + ' ' + this.principal.getUserLastName();
    }

    login() {
        this.modal = this.loginModalService.open();
    }

    changeLanguage(languageKey: string) {
        this.languageService.changeLanguage(languageKey);
    }

    getFlag(language: string) {
        return this.flags[language];
    }

    logout() {
        this.loginService.logout();
        this.router.navigate(['']);
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/components/main/header/page-header.component.ts